/**
 * Created by Ivan on 07.07.2026
 */

const StickersBookJokerView = function (bundleName) {
    return Prefab.instantiate(bundles.sticker_book_joker.jsons.stickers_book_joker_prefab_json, { bundleName });
};
